<template>
  <div class="filter-conditons-components">
    <div v-for="(item, idx) in dataList" :key="idx" class="condition">
      <div class="attribute">
        <el-select
          v-model="item.condition"
          size="small"
          class="w-200"
          :placeholder="$t('buriedPoint.attr')"
          :disabled="isView"
          filterable
          @change="changeAttribute(item, idx)"
        >
          <el-option-group v-for="attr in attrList" :key="attr.label" :label="attr.label">
            <el-option v-for="c in attr.groups" :key="c.value" :label="c.label" :value="c.value">
              <el-tooltip :content="c.tooltip" placement="top-start" effect="dark" :disabled="scrolling">
                <div>{{ c.label }}</div>
              </el-tooltip>
            </el-option>
          </el-option-group>
        </el-select>
      </div>
      <div class="connector">
        <ts-select
          v-model="item.connector"
          :disabled="isView"
          :options="item.operateOptionList"
          item-key="code"
          item-value="name"
          size="small"
          @change="changeOperateOption(item)"
        />
      </div>
      <div class="formTypes">
        <template v-if="item.connector && item.update && item.operateOption && item.operateOption.inputType">
          <template v-if="item.operateOption.inputType === 'MultiSelect'">
            <el-select
              v-model="item.value"
              class="multiple-select"
              size="small"
              allow-create
              default-first-option
              multiple
              filterable
              :loading="loading"
              :disabled="isView"
              @visible-change="visibleChange($event, item)"
              @change="changeValue(item)"
            >
              <el-option
                v-for="attr in item.attrValueList"
                :key="attr.value"
                :label="attr.label"
                :value="attr.value"
              >
                <span v-if="item.condition === 'business_channel'" class="m-r-10">{{ getChannelName(channels, attr.label) }}</span>
                <span v-else>{{ attr.label }}</span>
              </el-option>
            </el-select>
          </template>
          <template v-if="item.operateOption.inputType === 'Input'">
            <template v-if="item.operateOption.code === 'range'">
              <el-input
                v-model="item.start"
                :disabled="isView"
                size="small"
                class="w-150"
              />
              <span class="m-l-8 m-r-8 c-info">{{ $t('public.to') }}</span>
              <el-input
                v-model="item.end"
                :disabled="isView"
                size="small"
                class="w-150"
              />
              <span class="m-l-8 c-info flex-shrink-0">{{ $t('analysis.interval') }}</span>
            </template>
            <el-input v-else v-model="item.value" :disabled="isView" size="small" class="w-300" />
          </template>
          <template v-if="item.operateOption.inputType === 'Number'">
            <template v-if="item.operateOption.code === 'range'">
              <el-input-number
                v-model="item.start"
                :min="0"
                :max="item.end"
                :disabled="isView"
                :width="120"
                size="small"
                controls-position="right"
              />
              <span class="m-l-8 m-r-8 c-info">{{ $t('public.to') }}</span>
              <el-input-number
                v-model="item.end"
                :min="item.start"
                :disabled="isView"
                :width="120"
                size="small"
                controls-position="right"
              />
              <span class="m-l-8 c-info flex-shrink-0">{{ $t('analysis.interval') }}</span>
            </template>
            <el-input-number v-else v-model="item.value" size="small" :min="0" :disabled="isView" :width="120" controls-position="right" />
          </template>
          <template v-if="item.operateOption.inputType === 'DatePicker'">
            <el-date-picker
              v-if="item.operateOption.code === 'range'"
              v-model="item.value"
              value-format="yyyy-MM-dd"
              :disabled="isView"
              :range-separator="$t('public.to')"
              :start-placeholder="$t('public.startDate')"
              :end-placeholder="$t('public.endDate')"
              type="daterange"
              size="small"
              :placeholder="$t('public.pleaseChoose')"
            />
            <el-date-picker
              v-else
              v-model="item.value"
              value-format="yyyy-MM-dd"
              :disabled="isView"
              type="date"
              size="small"
              :placeholder="$t('public.pleaseChoose')"
            />
          </template>
          <template v-if="item.operateOption.inputType === 'DateTimePicker'">
            <el-date-picker
              v-if="item.operateOption.code === 'range'"
              v-model="item.value"
              value-format="yyyy-MM-dd"
              :disabled="isView"
              :range-separator="$t('public.to')"
              :start-placeholder="$t('public.startDateTime')"
              :end-placeholder="$t('public.endDateTime')"
              type="datetimerange"
              size="small"
              :placeholder="$t('public.pleaseChoose')"
            />
            <el-date-picker
              v-model="item.value"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="isView"
              type="datetime"
              size="small"
              :placeholder="$t('public.pleaseChoose')"
            />
          </template>
        </template>
      </div>
      <div v-if="!isView" class="handle-btn">
        <el-button type="text" :title="$t('group.delCondition')" icon="el-icon-delete" @click="handleDelete(idx)" />
        <el-tooltip v-if="idx === 0" placement="top">
          <div slot="content" v-html="$t('tooltip.t1')" />
          <svg-icon icon-class="question_mark" />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { clone } from '@U/handle'
import api from '@A'
import { Condition } from '@M/AnalyseDTO'
import { IndicatorOperatorList } from '@Const/connector'
import { getChannelName } from '@U/utilTool'

export default {
  name: 'FilterConditions',
  props: {
    conditions: {
      type: Array,
      default: () => []
    },
    attrList: {
      type: Array,
      default: () => []
    },
    appKey: {
      type: String,
      default: ''
    },
    eventName: {
      type: String,
      default: ''
    },
    isView: {
      type: Boolean,
      default: false
    },
    channels: {
      type: Array,
      default: () => ([])
    },
    multipleEvent: {
      type: Boolean,
      default: false
    },
    scrolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataList: clone(this.conditions),
      loading: false
    }
  },
  watch: {
    conditions: {
      handler(newValue) {
        this.dataList = clone(newValue)
      },
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    initConditions() {
      this.dataList.forEach(async(item, idx) => {
        if (item.condition) {
          this.initForAttribute(item, idx)
          if (!item.attrValueList) {
            item.attrValueList = []
          }
          this.init(item)
        }
      })
    },
    getChannelName,
    changeValue(item) {
      if (item.dataType === 'Number') {
        item.value = item.value.filter(val => (Number(val) + '' !== NaN + ''))
        item.value = item.value.map(val => {
          if (val.indexOf('.') > -1 && val.split('.')[1].length > 2) {
            return String(Number(val).toFixed(2))
          }
          return String(Number(val))
        })
      }
    },
    visibleChange(flag, item) {
      if (!flag) {
        return
      }
      if (!item.attrValueList || !item.attrValueList.length) {
        this.loading = true
        this.loadValueList(item).then(() => {
          this.loading = false
        }).catch(err => {
          console.log(err)
          this.loading = false
        })
      }
    },
    changeOperateOption(item) {
      // 操作符=区间
      if (item.connector === 'range') {
        if (item.dataType === 'Number') {
          this.$set(item, 'start', 0)
          this.$set(item, 'end', 1)
        } else if (item.dataType === 'ip') {
          this.$set(item, 'start', '')
          this.$set(item, 'end', '')
        } else {
          this.$set(item, 'value', null)
        }
      } else {
        this.$set(item, 'value', null)
      }
      this.init(item)
    },
    changeAttribute(item, idx) {
      this.initConditionValues(item)
      this.initForAttribute(item, idx)
      this.init(item)
    },
    // 初始化条件值&操作符
    initConditionValues(item) {
      this.$set(item, 'update', false)
      this.$set(item, 'attrValueList', [])
      this.$set(item, 'value', null)
      this.$set(item, 'connector', 'eq')
    },
    findAttributeObj(condition) {
      for (const list of this.attrList) {
        if (list.groups) {
          const obj = list.groups.find(item => item.value === condition)
          if (obj) {
            return obj
          }
        }
      }
      return null
    },
    // 初始化属性结构
    async initForAttribute(item, idx) {
      const currentItem = clone(this.findAttributeObj(item.condition))
      if (currentItem) {
        Object.assign(item, { dataType: currentItem.dataType })
      }

      let operateOptionList = []
      const obj = IndicatorOperatorList.find(ind => item.dataType === ind.dataType)
      if (obj) {
        operateOptionList = obj.operateOptionList
      }
      this.$set(item, 'operateOptionList', operateOptionList)
    },
    getEventName(current) {
      for (const list of this.attrList) {
        if (list.groups) {
          const obj = list.groups.find(group => group.value === current.condition)
          if (obj) {
            if ([this.$t('analysis.defaultAttr'), this.$t('analysis.pageAttr')].includes(list.label)) {
              return ''
            } else {
              return list.label
            }
          }
        }
      }
      return this.eventName
    },
    async loadValueList(item) {
      try {
        const params = { appKey: this.appKey, eventName: this.multipleEvent ? this.getEventName(item) : this.eventName, attribute: item.condition }
        const res = await api.analyseEvent.listEventParam(params)
        res.data = res.data || []
        const arr = []
        for (const data of res.data) {
          // 初始化30条
          if (data) {
            if (arr.length < 30) {
              const attr = item.condition.indexOf('.') !== -1 ? item.condition.split('.')[1] : item.condition
              arr.push({
                label: data[attr] ? data[attr] : this.$t('overview.unknown'),
                value: data[attr] ? data[attr] : this.$t('overview.unknown')
              })
            }
          }
        }
        this.$set(item, 'attrValueList', arr)
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    init(item) {
      if (!item.operateOptionList || !item.operateOptionList.length) {
        return
      }
      this.$set(item, 'update', false)
      const currentOperateOption = item.operateOptionList.find(i => i.code === item.connector)
      this.$set(item, 'operateOption', currentOperateOption)

      if (item.value instanceof Array) {
        if (['Input'].includes(item.operateOption.inputType)) {
          item.value = String(item.value)
        }
      }

      if (item.operateOption.inputType === 'Number' && item.operateOption.code !== 'range') {
        item.value = !item.value ? 0 : Number(item.value)
      }
      this.$set(item, 'update', true)
    },
    handleDelete(idx) {
      this.dataList.splice(idx, 1)
      if (!this.dataList.length) {
        this.$emit('clearAll')
      } else {
        this.$emit('update', this.dataList)
      }
    },
    add() {
      const obj = new Condition({
        condition: this.attrList && this.attrList.length ? this.attrList[0].groups[0].value : ''
      })
      this.dataList.push(obj)
      if (obj.condition) {
        this.initForAttribute(obj, this.dataList.length - 1)
        this.init(obj)
      }
      this.$emit('update', this.dataList)
    },
    commit() {
      this.handleData()
      this.$emit('update', this.dataList)
    },
    handleData() {
      const arr = []
      this.dataList.forEach((item, index) => {
        const value = item.value
        if (item.condition && item.connector) {
          if (!item.operateOption.inputType) {
            item.value = ''
            arr.push(item)
            return
          }
          if (item.connector === 'range') {
            if ((item.operateOption.inputType === 'Input' && this.$_.trim(item.start) && this.$_.trim(item.end)) || item.operateOption.inputType === 'Number') {
              arr.push(item)
            }
            return
          }
          if (((typeof value === 'number' && !isNaN(value)) || (value instanceof Array && value.length) || (this.$_.isString(value) && this.$_.trim(value)))) {
            arr.push(item)
          }
        }
      })
      this.dataList = arr
    }
  }
}
</script>

<style lang="scss">
.filter-conditons-components {
  .multiple-select {
    &.el-select {
      width: 300px;
      .el-tag {
        max-width: 90%;
        @include flexS;
        .el-select__tags-text {
          @include flex-vary;
          @include overflow;
          max-width: 100%;
        }
        .el-tag__close {
          @include flex-fixed;
        }
      }
    }
  }
  .el-tooltip {
    font-size: 13px;
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
  .condition {
    @include flexSS;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
    .connector {
      width: 200px;
    }
    .connector,
    .attribute,
    .handle-btn {
      @include flex-fixed;
    }
    .handle-btn {
      height: 36px;
      @include flexS;
      .el-icon-delete {
        color: #999;
        &:hover {
          .el-icon-delete {
            color: $subjectColor;
          }
        }
      }
      .el-button {
        padding: 8px 0;
      }
    }
    .attribute,
    .connector,
    .formTypes {
      margin-right: 10px;
    }
    .formTypes {
      @include flexS;
    }
    .el-icon-close {
      cursor: pointer;
    }
  }
  .el-date-editor.el-input {
    width: 180px;
  }
}
</style>
